import { Box, CloseButton, Flex, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import type { PromotionDiscountDto } from '~/clinician-api/models'

interface PromotionDiscountInfoBannerProps {
  promotionDiscount: PromotionDiscountDto
  onClose: () => void
}

const PromotionDiscountInfoBanner = ({
  promotionDiscount,
  onClose
}: PromotionDiscountInfoBannerProps) => {
  const heroImageUrl =
    'https://res.cloudinary.com/hellojoy/image/upload/v1750274081/image_oqlwdt.png'

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      bg="#F6F7FE"
      borderRadius="12px"
    >
      <CloseButton
        position="absolute"
        top="10px"
        right="10px"
        onClick={onClose}
        bg="white"
        color="primary"
        zIndex="1"
        _hover={{ bg: '#F9F9F9' }}
        _active={{ bg: '#F9F9F9' }}
      />

      <Box flex="4" py={{ base: 6, md: 8 }} px={{ base: 6, md: 10 }}>
        <VStack align="start" spacing={4}>
          <Text fontSize="24px" color="#2D54E8">
            💸<br />
            <b>
              {promotionDiscount.percentageOff}% off for{' '}
              {promotionDiscount.duration} months{' '}
            </b>{' '}
            when you choose a Standard or Plus plan
          </Text>
          <Text fontSize="16px">
            Over 45,000 mental health professionals have seen amazing results
            with Blueprint.
          </Text>
        </VStack>
      </Box>
      <Box
        position="relative"
        flex="3"
        bgImage={`url(${heroImageUrl})`}
        bgSize="cover"
        bgPosition="center"
        bgRepeat="no-repeat"
        pb={{ base: '240px', sm: '0' }}
        borderBottomRightRadius="8px"
        borderBottomLeftRadius={{ base: '8px', sm: '0' }}
        borderTopRightRadius={{ base: '0', sm: '8px' }}
      />
    </Flex>
  )
}
export default PromotionDiscountInfoBanner
